<template>
    <div class="live-list">
        <p class="month-title">{{ title }}</p>
        <div v-for="(item, index) in listData" :key="index" class="live-item-parent">
            <live-item :itemData="item"></live-item>
        </div>
    </div>
</template>

<script>
import LiveItem from '@components/liveList/LiveItem';
export default {
    name: 'LiveList',
    components: {
        LiveItem
    },
    props: {
        listData: {
            require: true,
            type: Array
        },
        title: {
            require: true,
            type: String
        }
    },
    data() {
        return {};
    },
    created() {}
};
</script>
<style lang="scss" scoped>
.live-list {
    box-sizing: border-box;
    padding: 25px 25px 25px 40px;
}
.month-title {
    box-sizing: border-box;
    width: 124px;
    line-height: 32px;
    background: url('~@images/base/time-bg.png') no-repeat center;
    padding-left: 38px;
    color: #fff;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    margin-bottom: 25px;
}
.live-item-parent:not(:last-child) {
    margin-bottom: 30px;
}
</style>
